import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'


const MissalV2Lazy = createLazyComponent(() => import('./MissalV2'))

const MissalV2 = (props) => <MissalV2Lazy {...props} />

export default MissalV2
